import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './es/es.json';
import en from './en/en.json';

i18next.use(initReactI18next).init({
    fallbackLng: 'es',
    resources: {
        es: {
            translation: es
        },
        en: {
            translation: en
        }
    },
    lng: sessionStorage.getItem("language") || "es"
});

export default i18next;
